import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import TravelLayout from '../layouts/TravelLayout';
import ExplorePage from '../features/explore/ExplorePage';
import JourneyDiscoveryPage from '../features/explore/JourneyDiscoveryPage';
import SocialPostComposePage from '../features/social-compose/SocialPostComposePage';
import SocialCheckInComposePage from '../features/social-compose/SocialCheckInComposePage';
import SocialPostEditPage from '../features/social-compose/SocialPostEditPage';
import FollowingFeedPage from '../features/social-following/FollowingFeedPage';
import SocialPostPage from '../features/social-post/SocialPostPage';
import CreatorPage from '../features/creator/CreatorPage';
import CreatorConnectionsPage from '../features/creator-connections/CreatorConnectionsPage';
import PublicJourneyPage from '../features/public-journey/PublicJourneyPage';
import SavedPage from '../features/saved/SavedPage';
import MyJourneysPage from '../features/my-journeys/MyJourneysPage';
import CreateJourneyPage from '../features/my-journeys/CreateJourneyPage';
import JourneyWorkspacePage from '../features/journey-workspace/JourneyWorkspacePage';
import JourneyTodayPage from '../features/journey-today/JourneyTodayPage';
import JourneyCollaborationTimelinePage from '../features/journey-collaboration-timeline/JourneyCollaborationTimelinePage';
import JourneyNoticesPage from '../features/journey-notice/JourneyNoticesPage';
import JourneyPlanningPage from '../features/journey-planning/JourneyPlanningPage';
import JourneyStaysPage from '../features/journey-accommodation/JourneyStaysPage';
import JourneyTransportPage from '../features/journey-transport/JourneyTransportPage';
import JourneyChecklistPage from '../features/journey-checklist/JourneyChecklistPage';
import JourneyBudgetPage from '../features/journey-budget/JourneyBudgetPage';
import JourneyExpensesPage from '../features/journey-expense/JourneyExpensesPage';
import JourneySplitPage from '../features/journey-split/JourneySplitPage';
import JourneyDecisionsPage from '../features/journey-decision/JourneyDecisionsPage';
import JourneyDecisionCreatePage from '../features/journey-decision/JourneyDecisionCreatePage';
import JourneyDecisionDetailPage from '../features/journey-decision/JourneyDecisionDetailPage';
import JourneySituationsPage from '../features/journey-situation/JourneySituationsPage';
import JourneySituationPage from '../features/journey-situation/JourneySituationPage';
import JourneyJournalPage from '../features/journey-journal/JourneyJournalPage';
import JourneyChatPage from '../features/journey-chat/JourneyChatPage';
import JourneyInvitationsPage from '../features/journey-invitation/JourneyInvitationsPage';
import GroupTripNoticesPage from '../features/group-trip-notice/GroupTripNoticesPage';
import NotificationsPage from '../features/social-notification/NotificationsPage';
import AnnouncementsPage from '../features/member-content-notices/AnnouncementsPage';
import AnnouncementDetailPage from '../features/member-content-notices/AnnouncementDetailPage';
import SiteMailPage from '../features/member-content-notices/SiteMailPage';
import SiteMailDetailPage from '../features/member-content-notices/SiteMailDetailPage';
import HostGroupTripsPage from '../features/group-trip/HostGroupTripsPage';
import HostCommercePage from '../features/host-commerce/HostCommercePage';
import HostGroupTripDetailPage from '../features/group-trip/HostGroupTripDetailPage';
import DisruptionCasesPage from '../features/group-trip/DisruptionCasesPage';
import DisruptionCaseDetailPage from '../features/group-trip/DisruptionCaseDetailPage';
import SettlementProposalsPage from '../features/group-trip/SettlementProposalsPage';
import SettlementProposalDetailPage from '../features/group-trip/SettlementProposalDetailPage';
import AcceptGroupTripClaimPage from '../features/group-trip/AcceptGroupTripClaimPage';
import CreateGroupTripPage from '../features/group-trip/CreateGroupTripPage';
import JourneyPublicationPickerPage from '../features/group-trip/JourneyPublicationPickerPage';
import EditGroupTripPage from '../features/group-trip/EditGroupTripPage';
import PublicGroupTripsPage from '../features/group-trip/PublicGroupTripsPage';
import PublicGroupTripPage from '../features/group-trip/PublicGroupTripPage';
import GroupTripActualPage from '../features/group-trip/GroupTripActualPage';
import TravelerActualPage from '../features/group-trip/TravelerActualPage';
import TravelInboxPage from '../features/messages/TravelInboxPage';
import TravelMessagesShell from '../features/messages/TravelMessagesShell';
import TravelThreadPage from '../features/messages/TravelThreadPage';
import MePage from '../features/me/MePage';
import PersonalMapPage from '../features/personal-map/PersonalMapPage';
import MyPublicationConsentsPage from '../features/me/MyPublicationConsentsPage';
import AdsDashboardPage from '../features/ads/AdsDashboardPage';
import PromotionCreatePage from '../features/ads/PromotionCreatePage';
import PromotionDetailPage from '../features/ads/PromotionDetailPage';
import CreativeCreatePage from '../features/ads/CreativeCreatePage';
import CreativeDetailPage from '../features/ads/CreativeDetailPage';
import CampaignCreatePage from '../features/ads/CampaignCreatePage';
import CampaignDetailPage from '../features/ads/CampaignDetailPage';
import LoginPage from '../auth/LoginPage';
import RegisterPage from '../auth/RegisterPage';
import ForgotPasswordPage from '../auth/ForgotPasswordPage';
import LegalContentPage from '../auth/LegalContentPage';
import GuestRoute from '../routes/GuestRoute';
import ProtectedRoute from '../routes/ProtectedRoute';

const ROUTER_FUTURE = { v7_startTransition: true, v7_relativeSplatPath: true };

export default function AppRouter() {
  return (
    <BrowserRouter future={ROUTER_FUTURE}>
      <TravelRoutes />
    </BrowserRouter>
  );
}

export function TravelRoutes() {
  return (
    <Routes>
      <Route element={<TravelLayout />}>
        <Route path="/" element={<Navigate to="/explore" replace />} />
        <Route path="/explore" element={<ExplorePage />} />
        <Route path="/discover/journeys" element={<JourneyDiscoveryPage />} />
        <Route path="/social/posts/:postId" element={<SocialPostPage />} />
        <Route path="/social/creators/:memberId" element={<CreatorPage tab="posts" />} />
        <Route path="/social/creators/:memberId/journeys" element={<CreatorPage tab="journeys" />} />
        <Route path="/social/creators/:memberId/followers" element={<CreatorConnectionsPage mode="followers" />} />
        <Route path="/social/creators/:memberId/following" element={<CreatorConnectionsPage mode="following" />} />
        <Route path="/public/journeys/:publicationId" element={<PublicJourneyPage />} />
        <Route path="/public/group-trips" element={<PublicGroupTripsPage />} />
        <Route path="/public/group-trips/:groupTripId" element={<PublicGroupTripPage />} />
        <Route element={<ProtectedRoute />}>
          <Route path="/social/following" element={<FollowingFeedPage />} />
          <Route path="/social/posts/new" element={<SocialPostComposePage />} />
          <Route path="/social/check-ins/new" element={<SocialCheckInComposePage />} />
          <Route path="/social/posts/:postId/edit" element={<SocialPostEditPage />} />
          <Route path="/me" element={<MePage />} />
          <Route path="/me/personal-map" element={<PersonalMapPage />} />
          <Route path="/me/publication-consents" element={<MyPublicationConsentsPage />} />
          <Route path="/me/ads" element={<AdsDashboardPage />} />
          <Route path="/me/ads/promotions/new" element={<PromotionCreatePage />} />
          <Route path="/me/ads/promotions/:promotionId" element={<PromotionDetailPage />} />
          <Route path="/me/ads/promotions/:promotionId/creatives/new" element={<CreativeCreatePage />} />
          <Route path="/me/ads/creatives/:creativeId" element={<CreativeDetailPage />} />
          <Route path="/me/ads/campaigns/new" element={<CampaignCreatePage />} />
          <Route path="/me/ads/campaigns/:campaignId" element={<CampaignDetailPage />} />
          <Route path="/saved" element={<SavedPage />} />
          <Route path="/saved-journeys" element={<Navigate to="/saved?contentType=JOURNEY_PUBLICATION" replace />} />
          <Route path="/messages" element={<TravelMessagesShell />}>
            <Route index element={<TravelInboxPage />} />
            <Route path="/messages/:conversationId" element={<TravelThreadPage />} />
          </Route>
          <Route path="/invitations" element={<JourneyInvitationsPage />} />
          <Route path="/notifications" element={<NotificationsPage />} />
          <Route path="/group-trip-notices" element={<GroupTripNoticesPage />} />
          <Route path="/announcements" element={<AnnouncementsPage />} />
          <Route path="/announcements/:announcementId" element={<AnnouncementDetailPage />} />
          <Route path="/site-mail" element={<SiteMailPage />} />
          <Route path="/site-mail/:mailId" element={<SiteMailDetailPage />} />
          {/* PD-GT-02: picker selects own PUBLISHED publication before /group-trips/new */}
          <Route path="/group-trips/picker" element={<JourneyPublicationPickerPage />} />
          <Route path="/group-trips/claim" element={<AcceptGroupTripClaimPage />} />
          <Route path="/group-trips/new" element={<CreateGroupTripPage />} />
          <Route path="/group-trips/:groupTripId/edit" element={<EditGroupTripPage />} />
          <Route path="/group-trips/:groupTripId/disruptions/:caseId" element={<DisruptionCaseDetailPage />} />
          <Route path="/group-trips/:groupTripId/disruptions" element={<DisruptionCasesPage />} />
          <Route path="/group-trips/:groupTripId/settlements/:proposalId" element={<SettlementProposalDetailPage />} />
          <Route path="/group-trips/:groupTripId/settlements" element={<SettlementProposalsPage />} />
          <Route path="/group-trips/:groupTripId/travelers/:travelerId/actual" element={<TravelerActualPage />} />
          <Route path="/group-trips/:groupTripId/actual" element={<GroupTripActualPage />} />
          <Route path="/group-trips/:groupTripId" element={<HostGroupTripDetailPage />} />
          <Route path="/group-trips" element={<HostGroupTripsPage />} />
          <Route path="/host/earnings" element={<HostCommercePage />} />
          <Route path="/journeys" element={<MyJourneysPage />} />
          <Route path="/journeys/new" element={<CreateJourneyPage />} />
          <Route path="/journeys/:journeyId/today" element={<JourneyTodayPage />} />
          <Route path="/journeys/:journeyId/timeline" element={<JourneyCollaborationTimelinePage />} />
          <Route path="/journeys/:journeyId/notices" element={<JourneyNoticesPage />} />
          <Route path="/journeys/:journeyId/planning" element={<JourneyPlanningPage />} />
          <Route path="/journeys/:journeyId/stays" element={<JourneyStaysPage />} />
          <Route path="/journeys/:journeyId/transport" element={<JourneyTransportPage />} />
          <Route path="/journeys/:journeyId/checklist" element={<JourneyChecklistPage />} />
          <Route path="/journeys/:journeyId/decisions/new" element={<JourneyDecisionCreatePage />} />
          <Route path="/journeys/:journeyId/decisions/:decisionId" element={<JourneyDecisionDetailPage />} />
          <Route path="/journeys/:journeyId/decisions" element={<JourneyDecisionsPage />} />
          <Route path="/journeys/:journeyId/situations/:situationId" element={<JourneySituationPage />} />
          <Route path="/journeys/:journeyId/situations" element={<JourneySituationsPage />} />
          <Route path="/journeys/:journeyId/journal" element={<JourneyJournalPage />} />
          <Route path="/journeys/:journeyId/chat" element={<JourneyChatPage />} />
          <Route path="/journeys/:journeyId/budget" element={<JourneyBudgetPage />} />
          <Route path="/journeys/:journeyId/expenses" element={<JourneyExpensesPage />} />
          <Route path="/journeys/:journeyId/split" element={<JourneySplitPage />} />
          <Route path="/journeys/:journeyId/people" element={<JourneyWorkspacePage />} />
          <Route path="/journeys/:journeyId" element={<JourneyWorkspacePage />} />
        </Route>
      </Route>
      <Route element={<GuestRoute />}>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />
      </Route>
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/agreement" element={<LegalContentPage type="agreement" />} />
      <Route path="/privacy-policy" element={<LegalContentPage type="privacy" />} />
      <Route path="*" element={<Navigate to="/explore" replace />} />
    </Routes>
  );
}
